module.exports = __webpack_public_path__ + "static/media/lawn.8774b432.png";